import './Footer.css'
import SocialIcon from './SocialIcon'

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-links">
          <SocialIcon 
            href="https://www.linkedin.com/in/luuk-verboeket-6a88021b5/" 
            title="LinkedIn"
            icon="linkedin"
          />
          
          <SocialIcon 
            href="https://www.instagram.com/fijneknaap" 
            title="Instagram"
            icon="instagram"
          />
          
          <SocialIcon 
            href="mailto:hello@luukverboeket.nl" 
            title="Email"
            icon="email"
            external={false}
          />

          <SocialIcon 
            href="https://github.com/elempiar" 
            title="GitHub"
            icon="github"
          />

          <SocialIcon 
            href="https://secure.runescape.com/m=hiscore_oldschool/hiscorepersonal?user1=Huell" 
            title="Old School RuneScape Hiscores"
            icon="osrs"
          />

          <SocialIcon 
            href="https://wiseoldman.net/players/Huell" 
            title="Old School RuneScape WiseOldMan"
            icon="wom"
          />

          <SocialIcon 
            href="https://open.spotify.com/user/combatcrab?si=a266b9efbdc84c7b" 
            title="Spotify"
            icon="spotify"
          />
          
        </div>
        
        <div className="footer-text">
          <p>&copy; 2025 Luuk Verboeket. Gemaakt met droge ogen, pijn aan mijn nek en een paar pilsjes 🍺</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
